const md = `
### Select datasets from over ten thousand industry-relevant datasources in our searchable library

Our extensive library meets the needs of financial and data analysts across industries. Upon request, we can easily add new APIs to your library.
`;

export default md;
